module.exports = __webpack_public_path__ + "static/media/kanban.1f547521.png";